import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/auth.guard';


export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'registration/:Id', loadChildren: () => import('./ext-user-management/registration/registration.module').then(m => m.RegistrationModule) },
  { path: 'forgotpassword', loadChildren: () => import('./ext-user-management/forgot-password/forgotpassword.module').then(m => m.ForgotpasswordModule) },
  { path: 'results', loadChildren: () => import('./ext-user-management/my-results/my-results.module').then(m => m.MyResultsModule) },
  { path: 'resetpassword', loadChildren: () => import('./ext-user-management/resest-password/resetpassword.module').then(m => m.ResetPasswordModule) },
  { path: 'login', loadChildren: () => import('./authentication/login/login.module').then(m => m.LoginModule) },
  { path: 'termsandcondition', loadChildren: () => import('./terms-and-conditions/termsandcondition.module').then(m => m.TermsAndConditionModule) },
  { path: 'home', loadChildren: () => import('./home/landingpage.module').then(m => m.LandingPageModule), canActivate : [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
